var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["insert-rec", "insert-shop-card", _vm.expiredClass] },
    [
      _c(
        "a",
        {
          staticClass: "insert-box sendAction padding-zero",
          attrs: {
            href: _vm.fields.linkUrl,
            "data-spm-data": "p",
            "data-spm-content": _vm.dataSpmContent,
            target: "_blank",
            "data-acode": "8886",
          },
        },
        [
          _c(
            "div",
            { staticClass: "external-poster" },
            [
              _vm.cardInfo.pluginType == 35
                ? [
                    _c(
                      "div",
                      { staticClass: "text-detail border-bottom-zero" },
                      [
                        _c("h5", { staticClass: "title" }, [
                          _vm._v(_vm._s(_vm.title)),
                        ]),
                        _vm._v(" "),
                        _vm.desc
                          ? _c("div", { staticClass: "content" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.desc) +
                                  "\n                    "
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.fields.btnText
                          ? _c(
                              "div",
                              { staticClass: "insert-btn-fix fix-position" },
                              [_vm._v(_vm._s(_vm.fields.btnText))]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      ref: "imgref",
                      staticClass: "cover",
                      attrs: { src: _vm.image, alt: "配图" },
                    }),
                  ]
                : [
                    _c("img", {
                      staticClass: "cover",
                      attrs: { src: _vm.image, alt: "配图" },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-detail border-top-zero" }, [
                      _c("h5", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.title)),
                      ]),
                      _vm._v(" "),
                      _vm.desc
                        ? _c("div", { staticClass: "content" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.desc) +
                                "\n                    "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.fields.btnText
                        ? _c(
                            "div",
                            { staticClass: "insert-btn-fix fix-position" },
                            [_vm._v(_vm._s(_vm.fields.btnText))]
                          )
                        : _vm._e(),
                    ]),
                  ],
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _vm.cardInfo.accountName && _vm.cardInfo.avatar
        ? _c("div", { staticClass: "rec" }, [
            _c("div", { staticClass: "rec-avator" }, [
              _c("img", { attrs: { src: _vm.cardInfo.avatar } }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "rec-text" }, [
              _vm._v(_vm._s(_vm.cardInfo.accountName) + "推荐"),
            ]),
            _vm._v(" "),
            _vm.status === 4 || _vm.status === 3
              ? _c("div", { staticClass: "rec-expired-tag" }, [
                  _vm._v("已失效"),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }